import { PostHogProvider } from 'posthog-js/react';
import { POSTHOG_HOST, POSTHOG_KEY } from '../../../constants/app-constants';
import { IFeatureFlagsProvider } from '../feature-flag-provider.interface';

export const PosthogFeatureFlagsProvider: React.FC<IFeatureFlagsProvider> = ({ children }: { children?: React.ReactNode }) => {
  const options = { api_host: POSTHOG_HOST };
  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
};
